import React from 'react';

export const Cell62 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      role="presentation"
      viewBox="0 0 87 87"
      {...props}
    >
      <circle cx={43.5} cy={43.5} r={43.5} fill="#fff" />
      <path
        fill="#fff"
        stroke="#27375f"
        strokeMiterlimit="10"
        strokeWidth="1.6px"
        d="M52.7 11.63H34.3l-9.2 15.94 9.2 15.93h18.4l9.2-15.93-9.2-15.94zM52.7 43.5H34.3l-9.2 15.94 9.2 15.93h18.4l9.2-15.93-9.2-15.94z"
      />
    </svg>
  );
};
